"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _core = require("@material-ui/core");

var _NotificationMessageSectionModule = _interopRequireDefault(require("./NotificationMessageSection.module.scss"));

var _FBUIConstants = require("../../../../utils/FBUIConstants");

var _NotificationIcon = _interopRequireDefault(require("../NotificationIcon/NotificationIcon"));

var _Button = _interopRequireDefault(require("../Button/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * # Notification Message Section
 * Foodbomb Notification Wrapper Component
 *
 * ## Modifiers
 * ### Types
 * ```
 * ['warning', 'error', 'success', 'info']
 * ```
 *
 * ### Sizes
 * ```
 * ['small', 'regular', 'large']
 * ```
 *
 * ## PropTypes:
 * ```js
 *  NotificationMessageSection.propTypes = {
 *    type: PropTypes.oneOf(Object.values(NOTIFICATION_MESSAGE_TYPES)).isRequired,
 *    className: PropTypes.string,
 *    children: PropTypes.node.isRequired,
 *    size: PropTypes.oneOf(Object.values(NOTIFICATION_MESSAGE_SIZES)),
 *    title: PropTypes.string,
 *    actionHandler: (props, propName) => {
 *      if (props.actionLabel === true && (props[propName] === undefined || typeof props[propName] !== 'function')) {
 *        return new Error('Please provide a actionHandler function!');
 *      }
 *      return 0;
 *    },
 *    actionLabel: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
 *    dismissable: PropTypes.bool,
 *
 *  };
 * ```
 */
var NotificationMessageSection = function NotificationMessageSection(_ref) {
  var type = _ref.type,
      size = _ref.size,
      className = _ref.className,
      children = _ref.children,
      title = _ref.title,
      actionHandler = _ref.actionHandler,
      actionLabel = _ref.actionLabel,
      dismissable = _ref.dismissable;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDismissed = _useState2[0],
      setIsDismissed = _useState2[1];

  var notificationSectionStyles = [_NotificationMessageSectionModule.default.NotificationSection];
  var colorStripStyles = [_NotificationMessageSectionModule.default.ColorStrip];

  if (className) {
    notificationSectionStyles.push(className);
  }

  if (size) {
    notificationSectionStyles.push(_NotificationMessageSectionModule.default[size]);
  }

  if (type) {
    notificationSectionStyles.push(_NotificationMessageSectionModule.default[type.toLowerCase()]);
    colorStripStyles.push(_NotificationMessageSectionModule.default[type.toLowerCase()]);
  }

  return !isDismissed ? /*#__PURE__*/_react.default.createElement("div", {
    className: notificationSectionStyles.join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: colorStripStyles.join(' ')
  }), /*#__PURE__*/_react.default.createElement(_NotificationIcon.default, {
    type: type,
    className: _NotificationMessageSectionModule.default.Icon
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _NotificationMessageSectionModule.default.ContentAndActionsContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _NotificationMessageSectionModule.default.ContentContainer
  }, title ? /*#__PURE__*/_react.default.createElement("div", {
    className: _NotificationMessageSectionModule.default.Title
  }, title) : null, children), actionHandler && actionLabel ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: type === _FBUIConstants.NOTIFICATION_MESSAGE_TYPES.ERROR ? _FBUIConstants.BUTTON_VARIANTS.DANGER : _FBUIConstants.BUTTON_VARIANTS.SECONDARY,
    onClick: actionHandler,
    className: _NotificationMessageSectionModule.default.ActionButton
  }, actionLabel) : null), dismissable ? /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick() {
      return setIsDismissed(true);
    },
    size: "small",
    className: _NotificationMessageSectionModule.default.IconButton
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    fontSize: "small"
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: _NotificationMessageSectionModule.default.MobileCloseButtonPlaceholder
  })) : null;
};

NotificationMessageSection.propTypes = {
  type: _propTypes.default.oneOf(Object.values(_FBUIConstants.NOTIFICATION_MESSAGE_TYPES)).isRequired,
  className: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  size: _propTypes.default.oneOf(Object.values(_FBUIConstants.NOTIFICATION_MESSAGE_SIZES)),
  title: _propTypes.default.string,
  actionHandler: function actionHandler(props, propName) {
    if (props.actionLabel === true && (props[propName] === undefined || typeof props[propName] !== 'function')) {
      return new Error('Please provide a actionHandler function!');
    }

    return 0;
  },
  actionLabel: _propTypes.default.oneOf([_propTypes.default.string, _propTypes.default.node]),
  dismissable: _propTypes.default.bool
};
var _default = NotificationMessageSection;
exports.default = _default;

//# sourceMappingURL=NotificationMessageSection.js.map